import React from "react"

export default function Search(props){
    return (
        <div className="about-page">
            <h3 className="main-button" id="back-button" onClick={props.onClick}>Back</h3>
            <div className="title-card">
                <div className="search-text">
                    <h1 id="search-title">Search by <b>City</b></h1>
                    <div id="search-body"> 
                        <h3>Coming Soon</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}